import { type PortfolioWithProductsDTO } from '@/domain/productPortfolio/types';
import { type UserBrief } from '@/domain/user/types';
import { registerResetFn } from '@/store/reset';
import { type TreeSelectSelectionKeysType } from 'primereact/treeselect';
import { create } from 'zustand';

import { type GroupBy, type ProductStage, type ViewMode } from '../types';

export interface MaturityFilters {
  selectedIndustries: TreeSelectSelectionKeysType | null;
  selectedPortfolios: PortfolioWithProductsDTO[];
  selectedProductOwners: UserBrief[];
  selectedProductManagers: UserBrief[];
  selectedTechManagers: UserBrief[];
  searchText: string;
  groupBy: GroupBy;
  productStage: ProductStage[];
  saleableSolutions: boolean;
  inRelease: boolean;
}

export interface MaturityFilterStore extends MaturityFilters {
  viewMode: ViewMode;
}

const initialState: MaturityFilterStore = {
  selectedIndustries: null,
  searchText: '',
  selectedPortfolios: [],
  selectedProductOwners: [],
  selectedProductManagers: [],
  selectedTechManagers: [],
  viewMode: 'Summary',
  productStage: [],
  groupBy: 'Grouping by Average',
  saleableSolutions: false,
  inRelease: false,
};

export const useMaturityFilterStore = create<MaturityFilterStore>()(() => ({ ...initialState }));

registerResetFn(() => useMaturityFilterStore.setState(initialState));

export const maturityFiltersSelector = (state: MaturityFilterStore): MaturityFilters => ({
  selectedIndustries: state.selectedIndustries,
  groupBy: state.groupBy,
  productStage: state.productStage,
  saleableSolutions: state.saleableSolutions,
  inRelease: state.inRelease,
  searchText: state.searchText,
  selectedPortfolios: state.selectedPortfolios,
  selectedProductManagers: state.selectedProductManagers,
  selectedProductOwners: state.selectedProductOwners,
  selectedTechManagers: state.selectedTechManagers,
});
